import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body pt-0" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "col-2 text-center" }
const _hoisted_6 = { class: "col-2 text-center" }
const _hoisted_7 = { class: "col-2 text-center" }
const _hoisted_8 = { class: "col-2 text-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rank_icon = _resolveComponent("rank-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("span", { class: "h5" }, [
          _createElementVNode("i", {
            class: "fas fa-clipboard-list fa-fw me-1",
            "aria-hidden": "true"
          }),
          _createTextVNode(" Recalificación de Rango ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[0] || (_cache[0] = _createElementVNode("th", { class: "col-4" }, [
                  _createElementVNode("div", null, "Rango")
                ], -1)),
                _createElementVNode("th", _hoisted_5, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.periods[0].format("MMM YY")), 1)
                ]),
                _createElementVNode("th", _hoisted_6, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.periods[1].format("MMM YY")), 1)
                ]),
                _createElementVNode("th", _hoisted_7, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.periods[2].format("MMM YY")), 1)
                ]),
                _createElementVNode("th", _hoisted_8, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.periods[3].format("MMM YY")), 1)
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ranksWithBonus, (rank) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: rank._id
                }, [
                  (rank.priority <= _ctx.currentRankPriority)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                        _createElementVNode("td", _hoisted_10, [
                          (_ctx.typeRankIconClass(rank.gtrLifeBonus?.type))
                            ? (_openBlock(), _createBlock(_component_rank_icon, {
                                key: 0,
                                "icon-class": _ctx.typeRankIconClass(rank.gtrLifeBonus?.type),
                                "extra-class": "fa-fw text-pink mx-1"
                              }, null, 8, ["icon-class"]))
                            : (_openBlock(), _createElementBlock("i", {
                                key: 1,
                                class: _normalizeClass([_ctx.typeIconClass(rank.gtrLifeBonus?.type), "mx-1"])
                              }, null, 2)),
                          _createTextVNode(" " + _toDisplayString(rank.name), 1)
                        ]),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                          return _createElementVNode("td", {
                            key: i,
                            class: "text-center"
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(
                        _ctx.getRankStatusIcon(
                          rank._id,
                          _ctx.periods[i - 1].format('YYYY-MM')
                        )
                      )
                            }, null, 2)
                          ])
                        }), 64))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}